__turbopack_context__.v({
  "container": "qcUfxG_container",
  "header": "qcUfxG_header",
  "methodSelectionLabel": "qcUfxG_methodSelectionLabel",
  "orderMethodOptions": "qcUfxG_orderMethodOptions",
  "orderMethodSelection": "qcUfxG_orderMethodSelection",
});
